<script lang="ts">
  import { useUserProfileStore } from '@/layers/MyProfile/stores/userProfile.store';

  const downloadAnchor = ref<HTMLAnchorElement>();

  export async function generateProfilePdf() {
    const userProfileStore = useUserProfileStore();
    await userProfileStore.generatePdf();
    if (userProfileStore.generatePdfState === 'isSuccess' && downloadAnchor.value) {
      downloadAnchor.value.click();
    }
  }
</script>

<script setup lang="ts">
  import { MpLoadingContainer, MpModal } from '@borg/ui';
  import { useUserProfileStore as _useUserProfileStore } from '@/layers/MyProfile/stores/userProfile.store';

  const userProfileStore = _useUserProfileStore();
</script>

<template>
  <MpModal
    :is-open="userProfileStore.generatePdfState === 'inProgress'"
    :close-button="false"
    :title="$t('GENERATING_PDF')"
    size="sm"
  >
    <MpLoadingContainer :is-loading="userProfileStore.generatePdfState === 'inProgress'" />
  </MpModal>
  <a
    v-if="userProfileStore.profilePdf"
    ref="downloadAnchor"
    :href="userProfileStore.profilePdf.url"
    :download="userProfileStore.profilePdf.name"
    style="display: none"
    target="_blank"
  >
    {{ $t('DOWNLOAD') }}
  </a>
</template>
